import { FunctionComponent } from "react";

export interface TemplateEditorProps {
  children?: string;

  html?: string;
  onChange?: (value: string) => void;
  onEditorInit?: () => void;
}

export const TemplateEditor: FunctionComponent<TemplateEditorProps> = () => {
  return null;
};